import React, { useState } from "react";
import { View, Text, StyleSheet, Platform, TextInput } from "react-native";

import Clipboard from "@react-native-community/clipboard";

import AppTheme from "../../AppTheme";
import { isWeb } from "../../../../helpers/utils";
import IntegrationIcons from "../../common/icons/integrations";

export default function CopyWidget(props) {
  const text = props.text;

  const [textInput, setTextInput] = useState("");
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async () => {
    setIsCopied(true);

    if (isWeb) {
      textInput.focus();
      document.execCommand("copy");
    } else {
      Clipboard.setString(installId);
    }
  };

  return (
    <View style={[props.style]}>
      <TextInput
        editable={false}
        ref={(ref) => setTextInput(ref)}
        value={text}
        selectTextOnFocus={true}
        style={[styles.textInput, isCopied ? { borderColor: "#239c9d" } : {}]}
      />

      <IntegrationIcons.ClipboardIcon
        onPress={copyToClipboard}
        isCopied={isCopied}
        style={{
          position: "absolute",
          right: 10,
          top: 10,
        }}
      />
      {isCopied ? <Text style={styles.copy}>copied to clipboard!</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  textInput: {
    height: 40,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    borderColor: "#ABADB3",
    borderWidth: 1,
    borderRadius: 4,
    paddingLeft: 10,
  },
  copy: {
    position: "absolute",
    right: 0,
    bottom: -15,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 12,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
});
